import { render, staticRenderFns } from "./Parcours.vue?vue&type=template&id=5008e1c2&scoped=true&"
import script from "./Parcours.vue?vue&type=script&lang=js&"
export * from "./Parcours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008e1c2",
  null
  
)

export default component.exports